import { ColumnSortType, TableColumnTypes } from '../../../../../model/table.model';
import { USER_COMPANY_STATUS } from '../../../../../enum/constants';

export const tableInvitersHeaders = [
  {
    value: 'email',
    sort: ColumnSortType.NONE,
    name: 'email',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'role',
    sort: ColumnSortType.NONE,
    name: 'role',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        {
          icon: 'outgoing_mail',
          label: 'resend',
          value: 'RESEND',
          unseen: ([row]: any[]) => !row.can_manage_team_action,
        },
        {
          icon: 'backspace',
          label: 'cancel',
          value: 'CANCEL',
          unseen: ([row]: any[]) => !row.can_manage_team_action,
        },
      ],
    translate: true,
  },
];

export const tableManagersHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox',
    translate: true,
  },
  {
     value: 'image_url',
    sort: ColumnSortType.NONE,
    name: 'avatar',
    type: TableColumnTypes.AVATAR,
    titleKey: 'full_name',
    // users.status: 'online' | 'offline', kept up to date by the `manager:status` socket event
    statusKey: 'status',
    className: 'table-header',
    disabled: true,
    translate: true
  },
  {
    value: 'first_name',
    sort: ColumnSortType.NONE,
    name: 'first_name',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'last_name',
    sort: ColumnSortType.NONE,
    name: 'last_name',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'role',
    sort: ColumnSortType.NONE,
    name: 'type',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'group',
    sort: ColumnSortType.NONE,
    name: 'role',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'membership_status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.MEMBERSHIP_STATUS,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'last_active_at',
    sort: ColumnSortType.NONE,
    name: 'last_login',
    type: TableColumnTypes.DATETIME,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'email',
    sort: ColumnSortType.NONE,
    name: 'email',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'phone',
    sort: ColumnSortType.NONE,
    name: 'phone_number',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        {
          icon: 'forward_to_inbox',
          label: 'resend_invite',
          value: 'RESEND_INVITE',
          unseen: ([row]: any[]) =>
            !row.can_manage_team_action ||
            row.membership_status !== USER_COMPANY_STATUS.INVITED,
        },
        {
          icon: 'cancel_schedule_send',
          label: 'cancel_invite',
          value: 'CANCEL_INVITE',
          unseen: ([row]: any[]) =>
            !row.can_manage_team_action ||
            row.membership_status !== USER_COMPANY_STATUS.INVITED,
        },
        {
          icon: 'logout',
          label: 'logout_manager',
          value: 'LOGOUT',
          unseen: ([row]: any[]) => !row.can_manage_team_action ||
            row.membership_status === USER_COMPANY_STATUS.INVITED,
        },
        {
          icon: 'block',
          label: 'suspend_employee',
          value: 'SUSPEND',
          unseen: ([row]: any[]) =>
            !row.can_manage_team_action || row.membership_status !== USER_COMPANY_STATUS.ACTIVE,
        },
        {
          icon: 'settings_backup_restore',
          label: 'restore',
          value: 'RESTORE',
          unseen: ([row]: any[]) =>
            !row.can_manage_team_action || row.membership_status !== USER_COMPANY_STATUS.SUSPENDED,
        },
      ],
    translate: true,
  },
];

export const tableGroupsHeaders = [
  {
    value: 'name',
    sort: ColumnSortType.NONE,
    name: 'name',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'edit', label: 'update_data', value: 'EDIT' },
        { icon: 'delete', label: 'delete', value: 'DELETE' },
      ],
    translate: true,
  },
];
